import { render } from "./serviceOverview.vue?vue&type=template&id=73004e24&scoped=true&ts=true"
import script from "./serviceOverview.vue?vue&type=script&lang=ts"
export * from "./serviceOverview.vue?vue&type=script&lang=ts"

import "./serviceOverview.vue?vue&type=style&index=0&id=73004e24&lang=scss&scoped=true"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-73004e24"]])

export default __exports__